export function formatIndianNumber(num) {
  // Convert number to string and split decimal part if any
if (isNaN(num)) {
    return num;
  }
if (num === null || num === undefined) {
    return num;
  }
  let [integer, decimal] = num.toString().split(".");

  // Last 3 digits stay together
  let lastThree = integer.slice(-3);
  let otherNumbers = integer.slice(0, -3);

  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }

  // Add commas every 2 digits in remaining part
  let formatted =
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

  return decimal ? formatted + "." + decimal : formatted;
}
